import type { SliderVO } from '~/types/auto/oj';
import { httpService } from '../http';

/**
 * 首页banner数组
 */
export function getHomeCarousel() {
  return httpService.get<SliderVO[]>(`/api/code-community/api/home-carousel`);
}

/**
 * 首页banner数组-新版
 */
export function getHomeCarouselNew() {
  return httpService.get<SliderVO[]>(`/api/code-community/api/home-slider`);
}
